// Utilitários para categorias com 1 nível de subcategorias (parent_id)

export const buildCategoryTree = (categories = []) => {
  const byId = Object.fromEntries(categories.map((c) => [c.category_id, c]));
  const childrenOf = {};
  const parentOf = {};
  const roots = [];
  const sortByOrder = (a, b) => (a.order ?? 0) - (b.order ?? 0) || a.name.localeCompare(b.name);
  for (const c of categories) {
    if (c.parent_id && byId[c.parent_id]) {
      (childrenOf[c.parent_id] ||= []).push(c);
      parentOf[c.category_id] = c.parent_id;
    } else {
      roots.push(c);
    }
  }
  roots.sort(sortByOrder);
  Object.values(childrenOf).forEach((arr) => arr.sort(sortByOrder));
  return { byId, childrenOf, parentOf, roots };
};

// Lista plana ordenada: principal seguida das suas subcategorias (depth 1)
export const flattenCategories = (categories = []) => {
  const { roots, childrenOf } = buildCategoryTree(categories);
  return roots.flatMap((r) => [{ ...r, depth: 0 }, ...(childrenOf[r.category_id] || []).map((s) => ({ ...s, depth: 1 }))]);
};

export const categoryPath = (categories = [], categoryId, fallback = "Sem categoria") => {
  const { byId } = buildCategoryTree(categories);
  const cat = byId[categoryId];
  if (!cat) return fallback;
  const parent = cat.parent_id ? byId[cat.parent_id] : null;
  return parent ? `${parent.name} › ${cat.name}` : cat.name;
};

// Produto pertence à categoria selecionada (ou a uma das suas subcategorias)
export const productInCategory = (product, selectedId, childrenOf = {}) =>
  selectedId === "all" ||
  product.category_id === selectedId ||
  (childrenOf[selectedId] || []).some((s) => s.category_id === product.category_id);
